import { useEffect, useState } from "react";

type CountdownProps = {
  targetDate: Date | string;
};

type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};

const CountdownTimer = ({ targetDate }: CountdownProps) => {
  const calculateTimeLeft = (): TimeLeft => {
    const difference = new Date(targetDate).getTime() - new Date().getTime();

    if (difference > 0) {
      return {
        hours: Math.floor(difference / (1000 * 60 * 60)),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return { hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex justify-center items-center gap-4">
      <span className="font-digital text-[64px] md:text-[110px] text-green-400">
        {String(timeLeft.seconds).padStart(2, "0")}
      </span>
      <span className="font-digital text-[64px] md:text-[110px] text-white">
        :
      </span>
      <span className="font-digital text-[64px] md:text-[110px] text-white">
        {String(timeLeft.minutes).padStart(2, "0")}
      </span>
      <span className="font-digital text-[64px] md:text-[110px] text-white">
        :
      </span>
      <span className="font-digital text-[64px] md:text-[110px] text-white">
        {String(timeLeft.hours).padStart(2, "0")}
      </span>
    </div>
  );
};

export default CountdownTimer;
